/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './follow.defs'
export { main as default } from './follow.defs'
